<div [formGroup]="formGroup" class="flex flex-col gap-2">
  <div class="flex flex-row gap-2">
    <mat-form-field class="flex grow" floatLabel="always">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description">
      @if ((description.touched || description.dirty) && description.errors?.required) {
        <mat-error>You must provide a description for this commodity</mat-error>
      }
      @if (!description.dirty) {
        <mat-hint>Searchable description</mat-hint>
      }
    </mat-form-field>
    <mat-form-field class="flex w-48" floatLabel="always">
      <mat-label>HS Code</mat-label>
      <input matInput formControlName="harmonizedCode">
      @if ((harmonizedCode.touched || harmonizedCode.dirty) && harmonizedCode.errors?.invalidHarmonizedCode) {
        <mat-error i18n>Expecting 0000.00.00.00</mat-error>
      }
      @if ((harmonizedCode.touched || harmonizedCode.dirty) && harmonizedCode.errors?.required) {
        <mat-error i18n>Required</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="flex flex-row gap-2">
    <mat-form-field class="flex w-24 grow shrink" floatLabel="always">
      <mat-label>Markings/Identifiers</mat-label>
      <input matInput formControlName="markings">
    </mat-form-field>
    <mat-form-field class="flex w-24 grow shrink" floatLabel="always">
      <mat-label>Country of Origin</mat-label>
      <mat-select formControlName="country">
        @for (country of countries; track country) {
          <mat-option [value]="country.code">{{ country.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-row gap-2">
    <mat-form-field class="flex w-24 grow shrink" floatLabel="always">
      <mat-label>Quantity</mat-label>
      <input matInput formControlName="quantity" type="number" min="1">
    </mat-form-field>
    <mat-form-field class="flex w-24 grow shrink" floatLabel="always">
      <mat-label>Unit</mat-label>
      <input matInput formControlName="unitOfMeasure">
    </mat-form-field>
    <mat-form-field class="flex w-24 grow shrink" floatLabel="always">
      <mat-label>Unit Price</mat-label>
      <input matInput formControlName="price"  type="number" min="0.01">
      <span matTextSuffix class="input-suffix">{{ currency }}</span>
    </mat-form-field>
    <mat-form-field class="flex w-24 grow shrink" floatLabel="always">
      <mat-label>Weight</mat-label>
      <input matInput formControlName="weight" type="number" min="0.01">
      <span matTextSuffix class="input-suffix">{{ Weight.suffix(weightUnit) }}</span>
    </mat-form-field>
  </div>
</div>